import { Button, Modal, Menu, Dropdown } from 'antd';
import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import TitlePage from '../../../../components/TitlePage';
import { ApplicationState } from '../../../../store';
import Filter from './components/Filter';
import { CloseOutlined, EllipsisOutlined, FilterOutlined } from '@ant-design/icons';
import { ExportBtn } from '../../../../components/_REFACTORED/ExportBtn';
import { ContFilter, Container } from './styles';
import { ColumnType } from 'antd/lib/table';
import { mask } from '../../../../utils/mask';
import { Sorter, sorterParamsHandle } from '../../../../utils/sorte';
import TableSort from '../../../../components/TableSort';
import { loadRequest } from '../../../../store/ducks/ordemCargaPage/actions';
import { TableSec } from '../../../../components/_REFACTORED/SecondaryTable';
import iconentrega from '../../../../assets/img/entrega.svg';
import iconcoleta from '../../../../assets/img/coleta.svg';
import ModalCriarAgendamento from '../../components/ModalCriarAgendamento';
import CardMobile from './components/CardMobile';
import { useWindowSize } from '../../../../hook/useWindowSize';
import GetStatus from '../../../../components/GetStatus';
import TextTable from '../../../../components/TextTable';
import Refresh from '../../../../components/Refresh';
import { IOrdemCargaPage } from '../../../../store/ducks/ordemCargaPage/types';
import TitleTable from '../../../../components/TitleTable';
import { exportDataOrdemCarga } from './hooks';
import { ordemCargaServices } from './services/ordemdeCargaService';

const OrdemCarga: React.FC = () => {
  const ordemCargas = useSelector((state: ApplicationState) => state.OrdemCargaPage.data);
  const loading = useSelector((state: ApplicationState) => state.OrdemCargaPage.loading);
  const pagination = useSelector((state: ApplicationState) => state.OrdemCargaPage.pagination);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const filter = useSelector((state: ApplicationState) => state.OrdemCargaPage.filter);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const [filterActive, setFilterActive] = useState<string[]>([]);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);
  const [isModalOrderVisible, setIsModalOrderVisible] = useState(false);

  const dispatch = useDispatch<Dispatch<Action>>();
  const { width }: any = useWindowSize();

  const getData = async () => {
    const { data } = await ordemCargaServices.getAllData(
      cddAtivo?.codCdd,
      filter,
      inscricaoAtiva,
      pagination.total
    );

    return exportDataOrdemCarga(data.ordensCarga);
  };

  useEffect(() => {
    setFilterActive(Object.keys(filter ?? {}));
  }, [filter]);

  const columns: ColumnType<IOrdemCargaPage>[] = [
    {
      title: <TitleTable>Tipo WMS</TitleTable>,
      dataIndex: 'tipoWms',
      key: 'tipoWms',
      align: 'center',
      width: 120,
      render: (text) => {
        const data =
          text === 'EXP' ? (
            <TextTable>
              Coleta
              <img
                width="10px"
                src={iconcoleta}
                alt="Saída"
                title="Saída"
                style={{ marginLeft: '10px' }}
              />
            </TextTable>
          ) : (
            <TextTable>
              Entrega{' '}
              <img
                width="10px"
                src={iconentrega}
                alt="Entrada"
                title="Entrada"
                style={{ marginLeft: '10px' }}
              />
            </TextTable>
          );
        return (
          <>
            <span>{data}</span>
          </>
        );
      },
    },
    {
      title: <TitleTable>Ordem de Carga</TitleTable>,
      dataIndex: 'ordemCarga',
      key: 'ordemCarga',
      align: 'center',
      width: 180,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 1,
      },
      render: (text) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informado</TextTable>;
      },
    },
    {
      title: <TitleTable>Status</TitleTable>,
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: 300,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 2,
      },
      render: (text) => {
        return <GetStatus acronym={text} />;
      },
    },
    {
      title: <TitleTable>Transportadora</TitleTable>,
      dataIndex: 'transportadora',
      key: 'transportadora',
      align: 'center',
      width: 300,
      sorter: {
        compare: Sorter.STRING,
        multiple: 3,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('transportadoraUf', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Placa</TitleTable>,
      dataIndex: 'placa',
      key: 'placa',
      align: 'center',
      width: 150,
      sorter: {
        compare: Sorter.STRING,
        multiple: 5,
      },
      render: (text) => {
        return text ? (
          <TextTable>{text?.toUpperCase()}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Veículo</TitleTable>,
      dataIndex: 'tipVei',
      key: 'tipVei',
      align: 'center',
      width: 150,
      sorter: {
        compare: Sorter.STRING,
        multiple: 5,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Motorista</TitleTable>,
      dataIndex: 'motorista',
      key: 'motorista',
      align: 'center',
      width: 300,
      render(text) {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>CPF</TitleTable>,
      dataIndex: 'cpfMotorista',
      key: 'cpfMotorista',
      align: 'center',
      width: 150,
      sorter: {
        compare: Sorter.STRING,
        multiple: 7,
      },
      render: (text: string) => {
        return text ? (
          <TextTable>{mask('cpfCnpj', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Peso</TitleTable>,
      dataIndex: 'pesoTotal',
      key: 'pesoTotal',
      align: 'center',
      width: 150,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 8,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('peso', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Valor</TitleTable>,
      dataIndex: 'vlrTotal',
      key: 'vlrTotal',
      align: 'center',
      width: 180,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 9,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('currency', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Ação</TitleTable>,
      dataIndex: 'acao',
      key: 'acao',
      width: 80,
      fixed: 'right',
      render: (text, record) => {
        const menuDropDown = (
          <Menu>
            <Menu.Item className="themeOrdemCargaAcao">
              <ModalCriarAgendamento
                ordemCarga={record}
                status={record?.status}
                atualizaTabelaOrdemCarga={() =>
                  dispatch(
                    loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd as number, pagination)
                  )
                }
              />
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menuDropDown}>
            <Button type="text" className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              <EllipsisOutlined
                style={{ fontSize: '30px', transform: 'rotate(90deg)', color: '#3c6ab4' }}
              />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <>
      <Refresh
        loadRequest={() =>
          dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd as number, pagination))
        }
      />
      <Filter />
      <Container>
        <TitlePage>
          <span>
            Ordem de Carga
            {/* <AnchorButton text={'ordemdecarga'} /> */}
          </span>

          {filterActive.length > 0 && (
            <ContFilter>
              {filterActive.map((item) => (
                <p key={item}>
                  {item === 'tipoWms' && (
                    <>
                      <FilterOutlined /> Tipo WMS
                    </>
                  )}
                  {item === 'ordemCarga' && (
                    <>
                      <FilterOutlined />
                      Ordem de carga
                    </>
                  )}
                  {item === 'codTransportadora' && (
                    <>
                      <FilterOutlined />
                      Transportadora
                    </>
                  )}

                  {item === 'codTipoVeiculo' && (
                    <>
                      <FilterOutlined />
                      Tipo de veículo
                    </>
                  )}
                </p>
              ))}
            </ContFilter>
          )}
          <div className="box">
            <ExportBtn
              onGetAllData={getData}
              screenData={exportDataOrdemCarga(ordemCargas as IOrdemCargaPage[])}
              filename={'solicitacoes'}
            />
          </div>
        </TitlePage>

        <Modal
          centered
          title="Ordem de carga"
          visible={isModalOrderVisible}
          onCancel={() => setIsModalOrderVisible(false)}
          maskClosable={false}
          closable={true}
          destroyOnClose={true}
          closeIcon={<CloseOutlined />}
          keyboard={true}
          width={911}
        ></Modal>

        <Modal
          centered
          title="Editar Entrega"
          visible={isModalEditVisible}
          onCancel={() => setIsModalEditVisible(false)}
          maskClosable={true}
          closable={true}
          destroyOnClose={true}
          closeIcon={<CloseOutlined />}
          keyboard={true}
          width={850}
          footer={[
            <Button key="back" size="middle" onClick={() => setIsModalEditVisible(false)}>
              Cancelar
            </Button>,
            <Button type="primary">Salvar</Button>,
          ]}
        ></Modal>
        {width > 768 && (
          <TableSort
            rowKey={(record: any, index: number) => record.ordemCarga.toString()}
            style={{ fontSize: 10, display: 'inline' }}
            columns={columns}
            scroll={{ x: 1200 }}
            size={'large'}
            onChange={(pagination: any, filters: any, sorter: any) => {
              dispatch(
                loadRequest(
                  filter,
                  inscricaoAtiva,
                  cddAtivo?.codCdd as number,
                  pagination,
                  sorterParamsHandle(sorter)
                )
              );
            }}
            pagination={pagination}
            className="table"
            dataSource={ordemCargas}
            loading={loading}
            expandable={{
              expandedRowRender: (record: IOrdemCargaPage) => (
                <TableSec ordemCarga={record.ordemCarga} codEmp={record.codEmp} />
              ),
            }}
          />
        )}
        {width <= 768 && (
          <CardMobile
            props={ordemCargas}
            pagination={pagination}
            loading={loading}
            inscricaoAtiva={inscricaoAtiva}
            cddAtivo={cddAtivo}
            filter={filter}
          />
        )}
      </Container>
    </>
  );
};

export default OrdemCarga;
